export default __webpack_public_path__ + "static/media/icon-bestellung-storniert.2082c363.svg";